module.exports = __webpack_public_path__ + "images/mobile/home/screenshot-eagleeye@2x-ff0ddc17c95d5d587b4510758ffa05fa.png";